export enum RatePeriod {
  Initial = 1,
  Revert = 2,
}
